import {
  appTitle,
  dateFormat,
  Departement,
  adnPageSize,
  WorkPlaces,
  RolesDescription,
} from "../common/GeneralConfigurations";
import { Space, Avatar, Tooltip, Checkbox } from "antd";
import { EditOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  getCareerLevels,
  getContractTypes,
  getEmployees,
  getEmployeesExcel,
} from "../../api/EmployeeApi";
import { EmployeeListForm } from "./EmployeeListForm";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "./ManageEmployeeListPage.css";
import { AppRoutes } from "../../AppRoutes";
import {
  getAuthenticatedUser,
  getAuthenticatedUserId,
  userHasRolePermission,
} from "../../api/ApiUtils";
import { getCountries } from "../../api/CountryApi";
import { getSetting } from "../../api/SettingApi";
import { getWorkPlaces } from "../../api/WorkPlaceApi";
import { GetUserByDepartmentId, getUserById } from "../../api/UserApi";
import { getPrimaveraDepartments } from "../../api/DepartmentApi";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import { useTranslation } from "react-i18next";

export const ManageEmployeeListPage = () => {
  const { t } = useTranslation();
  const title = t("employeeList.title");
  const REPORT_NAME = t("employeeList.reportName");

  const [employees, setEmployees] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [orderBy, setOrderBy] = useState("");
  const [searchOptions] = useState([]);
  const [careerLevelList, setCareerLevelList] = useState([]);
  const [contractTypeList, setContractTypeList] = useState([]);
  const [carrearLevelId, setCareerLevelId] = useState();
  const [contractTypeId, setContractTypeId] = useState();
  const [workPlaceList, setWorkPlaceList] = useState([]);
  const [managersList, setManagersList] = useState([]);
  const [humanResourcesList, setHumanResourcesList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [primaveraDepartmentList, setPrimaveraDepartmentList] = useState([]);
  const [primaveraDepartmentId, setPrimaveraDepartmentId] = useState("");
  const [dismissalComment, setDismissalComment] = useState("");
  const [settingADNProfileActive, setSettingADNProfileActive] = useState([]);
  const [settingProfileEmailActive, setSettingProfileEmailActive] = useState(
    []
  );
  const [settingIntegrationEmailActive, setSettingIntegrationEmailActive] =
    useState([]);
  const [
    settingFirstMonthAssessmentActive,
    setSettingFirstMonthAssessmentActive,
  ] = useState([]);
  const [startBirthDate, setStartBirthDate] = useState();
  const [endBirthDate, setEndBirthDate] = useState();
  const [startAdmissionDate, setStartAdmissionDate] = useState();
  const [endAdmissionDate, setEndAdmissionDate] = useState();
  const [startAdmissionCTIDate, setStartAdmissionCTIDate] = useState();
  const [endAdmissionCTIDate, setEndAdmissionCTIDate] = useState();
  const [startResignationDate, setStartResignationDate] = useState();
  const [endResignationDate, setEndResignationDate] = useState();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [number, setNumber] = useState("");
  const [gender, setGender] = useState("");
  const [referenceBy, setReferenceBy] = useState("");
  const [nationalityId, setNationalityId] = useState("");
  const [workPlaceId, setWorkPlaceId] = useState("");
  const [workPlaceIdHR, setWorkPlaceIdHR] = useState("");
  const [managerId, setManagerId] = useState([]);
  const [userIdHR, setUserIdHR] = useState([]);
  const [currentCompany, setCurrentCompany] = useState("");
  const [consultantType, setConsultantType] = useState(1);
  const [hiredType, setHiredType] = useState(1);
  const [hasIntegrationEmailSent, setHasIntegrationEmailSent] = useState(false);
  const [hasProfileEmailSent, setHasProfileEmailSent] = useState(false);
  const [hasAssessmentSent, setHasAssessmentSent] = useState(false);
  const [hasInquirySent, setHasInquirySent] = useState(false);
  const [hasCorpDone, setHasCorpDone] = useState(false);
  const [hasIntegrationEmailName, setHasIntegrationEmailName] = useState("");
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [isManager, setIsManager] = useState(false);
  const navigate = useNavigate();
  const [checkedIds, setCheckedIds] = useState([]);

  useEffect(() => {
    document.title = `${appTitle} - ${t("employeeList.title")}`;

    getCareerLevels().then((res) => {
      setCareerLevelList(res.data);
    });

    getContractTypes().then((res) => {
      setContractTypeList(res.data);
    });

    getCountryList();
    getManagersList();
    getHumanResourcesList();
    getWorkPlacesList();
    getPrimaveraDepartmentsList();
    getSettingADNProfileActive();
    getSettingProfileEmailActive();
    getSettingIntegrationEmailActive();
    getSettingFirstMonthAssessmentActive();

    if (userHasRolePermission("Manager")) {
      var user = getAuthenticatedUser();
      if (user.departmentId === Departement.Manager)
        setManagerId([parseInt(getAuthenticatedUserId())]);
    }
  }, []);

  useEffect(() => {
    getUserById(getAuthenticatedUserId()).then((res) => {
      const NexelOrChiefIds = [1, 2, 3, 20];
      if (
        res.data.departmentId === Departement.Manager &&
        !NexelOrChiefIds.includes(res.data.positionId)
      ) {
        setIsManager(true);
      }
    });
  }, []);

  const getPrimaveraDepartmentsList = async () => {
    getPrimaveraDepartments()
      .then((res) => {
        setPrimaveraDepartmentList(res.data);
      })
      .catch((err) => console.log(err));
  };

  const checkLocalVariables = () => {
    let storageVariables = JSON.parse(localStorage.getItem("EmployeeFilters"));

    if (storageVariables !== null) {
      setSearchName(storageVariables.searchName);
      setOrderBy(storageVariables.orderBy);
      setCurrentPage(storageVariables.currentPage);
      setConsultantType(storageVariables.consultantType);
      setContractTypeId(storageVariables.contractType);
      setCareerLevelId(storageVariables.carrearLevel);
      setHiredType(storageVariables.hiredType);
    }

    clearLocalVariables();
  };

  const saveLocalVariables = () => {
    let localVariables = {
      searchName: searchName,
      orderBy: orderBy,
      currentPage: currentPage,
      consultantType: consultantType,
      contractType: contractTypeId,
      carrearLevel: carrearLevelId,
      hiredType: hiredType,
    };
    localStorage.setItem("EmployeeFilters", JSON.stringify(localVariables));
  };

  const clearLocalVariables = () => {
    localStorage.removeItem("EmployeeFilters");
  };

  useEffect(() => {
    const employeeTimeOut = setTimeout(() => {
      getEmployeesData();
    }, 500);

    return () => {
      clearTimeout(employeeTimeOut);
    };
  }, [
    searchName,
    orderBy,
    currentPage,
    contractTypeId,
    carrearLevelId,
    consultantType,
    hiredType,
    email,
    number,
    phone,
    gender,
    nationalityId,
    workPlaceId,
    workPlaceIdHR,
    managerId,
    userIdHR,
    currentCompany,
    startBirthDate,
    endBirthDate,
    startAdmissionDate,
    endAdmissionDate,
    startAdmissionCTIDate,
    endAdmissionCTIDate,
    startResignationDate,
    endResignationDate,
    referenceBy,
    hasCorpDone,
    hasInquirySent,
    hasIntegrationEmailSent,
    hasProfileEmailSent,
    hasAssessmentSent,
    primaveraDepartmentId,
    dismissalComment,
  ]);

  const getEmployeesData = async () => {
    setTableLoading(true);
    let isConsultant;
    if (consultantType === 1) {
      isConsultant = true;
    } else if (consultantType === 2) {
      isConsultant = false;
    }

    await getEmployees(
      currentPage,
      adnPageSize,
      orderBy,
      searchName,
      email,
      contractTypeId,
      carrearLevelId,
      isConsultant,
      hiredType != null ? (hiredType === 1 ? true : false) : "",
      number,
      phone,
      gender,
      nationalityId,
      workPlaceId,
      workPlaceIdHR,
      managerId === 2 ? 0 : managerId,
      userIdHR,
      currentCompany,
      referenceBy,
      startBirthDate,
      endBirthDate,
      startAdmissionDate,
      endAdmissionDate,
      startAdmissionCTIDate,
      endAdmissionCTIDate,
      startResignationDate,
      endResignationDate,
      hasCorpDone,
      hasInquirySent,
      hasIntegrationEmailSent,
      hasProfileEmailSent,
      hasAssessmentSent,
      primaveraDepartmentId,
      dismissalComment
    ).then((res) => {
      res.data.result.forEach((element) => {
        element.admissionDate = moment(element.admissionDate)?.format(
          dateFormat
        );
      });

      setTableLoading(false);
      setLoading(false);
      setEmployees(res.data.result);
      setTotalRecords(res.data.totalRecords);
    });
  };

  const getCountryList = async () => {
    getCountries().then((res) => {
      setCountryList(res.data);
    });
  };

  const getSettingADNProfileActive = async () => {
    let settingId = "CF367BD3-9DC6-428B-A233-C44D76981741";
    getSetting(settingId).then((res) => {
      setSettingADNProfileActive(res.data);
    });
  };

  const getSettingProfileEmailActive = async () => {
    let settingId = "BCCD6F54-9EF7-4DED-8645-F2F02B67DC88";
    getSetting(settingId).then((res) => {
      setSettingProfileEmailActive(res.data);
    });
  };

  const getSettingIntegrationEmailActive = async () => {
    let settingId = "0E65B49A-38CF-4410-AA74-EB716627B102";
    getSetting(settingId).then((res) => {
      setSettingIntegrationEmailActive(res.data);
    });
  };

  const getSettingFirstMonthAssessmentActive = async () => {
    let settingId = "E28D0977-A710-430C-AC44-902570294896";
    getSetting(settingId).then((res) => {
      setSettingFirstMonthAssessmentActive(res.data);
    });
  };

  const getManagersList = async () => {
    GetUserByDepartmentId(Departement.Manager).then((res) => {
      if (res.status === 200) {
        const filteredManagers = res.data.result.filter(
          (manager) => manager.deleted === false
        );
        setManagersList(filteredManagers);
      }
    });
    };

    const getHumanResourcesList = async () => {
        GetUserByDepartmentId(Departement.HumanResources).then((res) => {
          if (res.status === 200) {
              const filteredHumanResources = res.data.result.filter(
                  (humanResource) => humanResource.deleted === false
              );
              filteredHumanResources.unshift({
                  id: "00000000-0000-0000-0000-000000000000",
                  name: t("employeeList.notApplicable")
              })
              setHumanResourcesList(filteredHumanResources);
          }
        });
  };

  const getWorkPlacesList = async () => {
    getWorkPlaces()
      .then((res) => {
        setWorkPlaceList(res.data);
      })
      .catch((err) => console.log(err));
  };

  const handleTableChanges = async (pagination, filters, sorter, extra) => {
    sorter.order === "descend"
      ? setOrderBy("-" + sorter.field)
      : setOrderBy(sorter.field);
  };

  const FirstLastName = (name) => {
    let fullName = name.split(" ");
    let firstName = fullName[0];
    return firstName.concat(" " + fullName[fullName.length - 1]);
  };

  const columns = [
    (userHasRolePermission(RolesDescription.HumanResources) ||
      userHasRolePermission(RolesDescription.Admin)) && {
      title: "",
      dataIndex: "id",
      key: "id",
      sorter: false,
      render: (text, record) => (
        <Space style={{ display: "flex", justifyContent: "center" }}>
          <Checkbox
            className="checkBoxSelect"
            id={record.id}
            name={"consutant_" + record.id}
            checked={checkedIds.includes(record.id)}
            onChange={() => handleCheckboxChange(record.id)}
          ></Checkbox>
        </Space>
      ),
      width: "6%",
    },
    {
      title: t("employeeList.columns.name"),
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: "20%",
      render: (text, record) => (
        <div className="AvatarName">
          {/* <Avatar size="large" src={record.image} /> */}
          <Link
            to={AppRoutes.consultantById.createPath(record.id)}
            target="_blank"
          >
            {FirstLastName(text)}
          </Link>
        </div>
      ),
    },
    {
      title: t("employeeList.columns.email"),
      dataIndex: "email",
      key: "email",
      width: "20%",
      sorter: true,
    },
    {
      title: t("employeeList.columns.contractType"),
      dataIndex: "contractType",
      key: "contractType",
      width: "7%",
      render(text, record) {
        return {
          props: {
            style: {
              textAlign: "center",
            },
          },
          children: <div> {text ? text.split(" ")[0] : <></>}</div>,
        };
      },
    },
    {
      title: t("employeeList.columns.manager"),
      dataIndex: "managerCode",
      key: "managerCode",
      width: "7%",
      sorter: true,
    },
    {
      title: t("employeeList.columns.careerLevel"),
      dataIndex: "carrearLevel",
      key: "carrearLevel",
      width: "16%",
    },
    {
      title: t("employeeList.columns.admissionDate"),
      dataIndex: "admissionDate",
      key: "admissionDate",
      width: "11%",
      sorter: true,
    },
    {
      title: t("employeeList.columns.missing"),
      key: "tasks",
      width: "13%",
      render: (text, record) =>
        record.isConsultant && (
          <>
            {!record.hasInquirySent &&
              settingADNProfileActive.value === "TRUE" && (
                <Tooltip title={t("employeeList.tooltips.adnProfile")}>
                  <Avatar className="AvatarColorGreen" size="small" gap={1}>
                    AP
                  </Avatar>
                </Tooltip>
              )}
            {!record.hasIntegrationEmailSent &&
              settingIntegrationEmailActive.value === "TRUE" && (
                <Tooltip title={t("employeeList.tooltips.integrationEmail")}>
                  <Avatar className="AvatarColorRed" size="small" gap={1}>
                    IE
                  </Avatar>
                </Tooltip>
              )}
            {!record.hasProfileEmailSent &&
              settingProfileEmailActive.value === "TRUE" && (
                <Tooltip title={t("employeeList.tooltips.profileEmail")}>
                  <Avatar className="AvatarColorBlue" size="small" gap={1}>
                    PE
                  </Avatar>
                </Tooltip>
              )}
            {!record.hasCorpDone && (
              <Tooltip title={t("employeeList.tooltips.corpDone")}>
                <Avatar className="AvatarColorYellow" size="small" gap={1}>
                  CD
                </Avatar>
              </Tooltip>
            )}
            {!record.hasAssessmentSent &&
              settingFirstMonthAssessmentActive.value === "TRUE" && (
                <Tooltip
                  title={t("employeeList.tooltips.firstMonthAssessment")}
                >
                  <Avatar className="AvatarColorGray" size="small" gap={1}>
                    FM
                  </Avatar>
                </Tooltip>
              )}
          </>
        ),
    },
    {
      title: t("employeeList.columns.action"),
      key: "action",
      ellipsis: true,
      width: "6%",
      render: (text, record) => (
        <Space style={{ display: "flex", justifyContent: "center" }}>
          <EditOutlined onClick={() => handleEdit(record.id)} />
        </Space>
      ),
    },
  ].filter(Boolean);

  const handleEdit = (consultantId) => {
    saveLocalVariables();
    navigate(AppRoutes.consultantById.createPath(consultantId));
  };

  const handleAdd = () => {
    navigate(AppRoutes.consultant.path);
  };

  const handleCheckboxChange = (id) => {
    let newChecked = [...checkedIds];

    if (!newChecked.includes(id)) {
      newChecked.push(id);
      if (newChecked.length > 2) newChecked.shift(); // remove o mais antigo
    } else {
      newChecked = newChecked.filter((i) => i !== id); // desmarca
    }

    setCheckedIds(newChecked);
  };

  const handleSearch = (value) => {
    if (value.length >= 3) {
      setSearchName(value);
      setCurrentPage(1);
    } else {
      setSearchName("");
      setCurrentPage(1);
    }
  };

  const handleSelect = (value) => {
    setCurrentPage(1);
    setSearchName(value);
  };

  const handleChangeContractType = (value) => {
    setContractTypeId(value);
    setCurrentPage(1);
  };

  const handleChangeCareerLevel = (value) => {
    setCareerLevelId(value);
    setCurrentPage(1);
  };

  const handleChangeEmail = (value) => {
    setEmail(value.target.value);
    setCurrentPage(1);
  };

  const handleChangePhone = (value) => {
    setPhone(value);
    setCurrentPage(1);
  };

  const handleChangeNUmber = (value) => {
    setNumber(value.target.value);
    setCurrentPage(1);
  };

  const handleChangeGender = (value) => {
    setGender(value);
    setCurrentPage(1);
  };

  const handleChangeCountry = (value) => {
    setNationalityId(value);
    setCurrentPage(1);
  };

  const handleChangeManager = (value) => {
    setManagerId(value);
    setCurrentPage(1);
  };

  const handleChangeUserHR = (value) => {
    setUserIdHR(value);
    setCurrentPage(1);
  };

  const handleChangeWorkPlace = (value) => {
    setWorkPlaceId(value);
    setCurrentPage(1);
  };
  const handleChangeWorkPlaceHR = (value) => {
    setWorkPlaceIdHR(value);
    setCurrentPage(1);
  };

  const handleChangeCurrentCompany = (value) => {
    setCurrentCompany(value.target.value);
    setCurrentPage(1);
  };

  const handleChangeBirthDate = (value) => {
    if (value) {
      setStartBirthDate(moment(value[0]).format("yyyy-MM-DD"));
      setEndBirthDate(moment(value[1]).format("yyyy-MM-DD"));
      setCurrentPage(1);
    } else {
      setStartBirthDate([]);
      setEndBirthDate([]);
    }
  };

  const handleChangeAdmissionDate = (value) => {
    if (value) {
      setStartAdmissionDate(moment(value[0]).format("yyyy-MM-DD"));
      setEndAdmissionDate(moment(value[1]).format("yyyy-MM-DD"));
      setCurrentPage(1);
    } else {
      setStartAdmissionDate([]);
      setEndAdmissionDate([]);
    }
  };

  const handleChangeAdmissionCTIDate = (value) => {
    if (value) {
      setStartAdmissionCTIDate(moment(value[0]).format("yyyy-MM-DD"));
      setEndAdmissionCTIDate(moment(value[1]).format("yyyy-MM-DD"));
      setCurrentPage(1);
    } else {
      setStartAdmissionCTIDate([]);
      setEndAdmissionCTIDate([]);
    }
  };

  const handleChangeResignationDate = (value) => {
    if (value) {
      setStartResignationDate(moment(value[0]).format("yyyy-MM-DD"));
      setEndResignationDate(moment(value[1]).format("yyyy-MM-DD"));
      setCurrentPage(1);
    } else {
      setStartResignationDate([]);
      setEndResignationDate([]);
    }
  };

  const handleChangeReferenceBy = (value) => {
    setReferenceBy(value);
    setCurrentPage(1);
  };

  const handleChangeConsultantType = (value) => {
    setConsultantType(value);
    setCurrentPage(1);
  };

  const handleChangeHiredType = (value) => {
    setHiredType(value);
    setCurrentPage(1);
  };

  const handleChangePrimaveraDepartment = (value) => {
    setPrimaveraDepartmentId(value);
    setCurrentPage(1);
  };

  const handleChangeDismissalComment = (value) => {
    setDismissalComment(value.target.value);
    setCurrentPage(1);
  };

  const handleChangeMissingCorp = (value) => {
    setHasCorpDone(value.target.checked);
  };

  const handleChangeMissingInquiry = (value) => {
    setHasInquirySent(value.target.checked);
  };

  const handleChangeMissingProfile = (value) => {
    setHasProfileEmailSent(value.target.checked);
  };

  const handleChangeMissingIntegration = (value) => {
    setHasIntegrationEmailSent(value.target.checked);
    if (value.target.checked) {
      setHasIntegrationEmailName("Integration");
    } else {
      setHasIntegrationEmailName("");
    }
  };

  const handleChangeMissingAssessment = (value) => {
    setHasAssessmentSent(value.target.checked);
  };

  const getRowClassName = (record, index) => {
    return record.managerWorkPlaceId === WorkPlaces.Porto ? "porto-bcolor" : "";
  };

  const handleEmployeesExcel = async () => {
    let isConsultant;
    if (consultantType === 1) {
      isConsultant = true;
    } else if (consultantType === 2) {
      isConsultant = false;
    }

    await getEmployeesExcel(
      currentPage,
      adnPageSize,
      orderBy,
      searchName,
      email,
      contractTypeId,
      carrearLevelId,
      isConsultant,
      hiredType != null ? hiredType === 1 : "",
      number,
      phone,
      gender,
      nationalityId,
      workPlaceId,
      workPlaceIdHR,
      managerId === 2 ? 0 : managerId,
      userIdHR,
      currentCompany,
      referenceBy,
      startBirthDate,
      endBirthDate,
      startAdmissionDate,
      endAdmissionDate,
      startAdmissionCTIDate,
      endAdmissionCTIDate,
      startResignationDate,
      endResignationDate,
      hasCorpDone,
      hasInquirySent,
      hasIntegrationEmailSent,
      hasProfileEmailSent,
      hasAssessmentSent,
      primaveraDepartmentId,
      dismissalComment
    )
      .then((res) => {
        if (res.status === 200) {
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const a = document.createElement("a");
          a.href = url;
          a.download = `${REPORT_NAME}.xlsx`;
          a.click();
          window.URL.revokeObjectURL(url);
        } else if (res && res.data && res.data.errors) {
          res.data.errors.map((e) => {
            AdnMessageError(e.message);
            return null;
          });
        } else {
          AdnMessageError(t("employeeList.errors.couldNotGenerateReport"));
        }
      })
      .catch(() => {
        AdnMessageError(t("employeeList.errors.couldNotGenerateReport"));
      });
  };

  return (
    <EmployeeListForm
      title={title}
      currentPage={currentPage}
      pageSize={adnPageSize}
      totalRecords={totalRecords}
      handleTableChanges={handleTableChanges}
      handleChangePage={setCurrentPage}
      handleSearch={handleSearch}
      handleSelect={handleSelect}
      handleAdd={handleAdd}
      employees={employees}
      searchOptions={searchOptions}
      columns={columns}
      getRowClassName={getRowClassName}
      careerLevelList={careerLevelList}
      contractTypeList={contractTypeList}
      countryList={countryList}
      settingADNProfileActive={settingADNProfileActive}
      managersList={managersList}
      humanResourcesList={humanResourcesList}
      workPlaceList={workPlaceList}
      primaveraDepartmentList={primaveraDepartmentList}
      handleChangeContractType={handleChangeContractType}
      handleChangeCareerLevel={handleChangeCareerLevel}
      handleChangeConsultantType={handleChangeConsultantType}
      handleChangeHiredType={handleChangeHiredType}
      handleChangeEmail={handleChangeEmail}
      handleChangeNUmber={handleChangeNUmber}
      handleChangePhone={handleChangePhone}
      handleChangeGender={handleChangeGender}
      handleChangeCountry={handleChangeCountry}
      handleChangeManager={handleChangeManager}
      handleChangeUserHR={handleChangeUserHR}
      handleChangeWorkPlace={handleChangeWorkPlace}
      handleChangeWorkPlaceHR={handleChangeWorkPlaceHR}
      handleChangeCurrentCompany={handleChangeCurrentCompany}
      handleChangeBirthDate={handleChangeBirthDate}
      handleChangeAdmissionDate={handleChangeAdmissionDate}
      handleChangeAdmissionCTIDate={handleChangeAdmissionCTIDate}
      handleChangeResignationDate={handleChangeResignationDate}
      handleChangeReferenceBy={handleChangeReferenceBy}
      handleChangePrimaveraDepartment={handleChangePrimaveraDepartment}
      handleChangeDismissalComment={handleChangeDismissalComment}
      handleChangeMissingCorp={handleChangeMissingCorp}
      handleChangeMissingInquiry={handleChangeMissingInquiry}
      handleChangeMissingProfile={handleChangeMissingProfile}
      handleChangeMissingIntegration={handleChangeMissingIntegration}
      handleChangeMissingAssessment={handleChangeMissingAssessment}
      loading={loading}
      carrearLevel={carrearLevelId}
      contractType={contractTypeId}
      consultantType={consultantType}
      hiredType={hiredType}
      searchName={searchName}
      email={email}
      phone={phone}
      number={number}
      gender={gender}
      nationalityId={nationalityId}
      workPlaceId={workPlaceId}
      workPlaceIdHumanResource={workPlaceIdHR}
      managerId={managerId}
      userIdHumanResource={userIdHR}
      currentCompany={currentCompany}
      primaveraDepartmentId={primaveraDepartmentId}
      dismissalComment={dismissalComment}
      tableLoading={tableLoading}
      hasCorpDone={hasCorpDone}
      hasInquirySent={hasInquirySent}
      hasIntegrationEmailSent={hasIntegrationEmailSent}
      hasProfileEmailSent={hasProfileEmailSent}
      hasAssessmentSent={hasAssessmentSent}
      hasIntegrationEmailName={hasIntegrationEmailName}
      isManager={isManager}
      handleEmployeesExcel={handleEmployeesExcel}
      checkedIds={checkedIds}
      setCheckedIds={setCheckedIds}
      saveLocalVariables={saveLocalVariables}
      checkLocalVariables={checkLocalVariables}
    />
  );
};
